var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.142,
    height: 38.568,
    viewBox: "0 0 32.142 38.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.657 5.625)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.684,101.573l-2.761-4.6a13.671,13.671,0,0,1-1.946-7.029V85.916a11.249,11.249,0,1,0-22.5,0v4.029a13.671,13.671,0,0,1-1.946,7.029l-2.761,4.6a.8.8,0,0,0,.689,1.217H73.995a.8.8,0,0,0,.689-1.217Zm-29.8-.391L46.91,97.8a15.264,15.264,0,0,0,2.176-7.855V85.916a9.642,9.642,0,1,1,19.284,0v4.029A15.278,15.278,0,0,0,70.545,97.8l2.031,3.383Z",
    transform: "translate(-42.657 -74.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.514)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M216.547,0a3.217,3.217,0,0,0-3.214,3.214V6.428a.8.8,0,0,0,1.607,0V3.214a1.607,1.607,0,0,1,3.214,0V6.428a.8.8,0,0,0,1.607,0V3.214A3.217,3.217,0,0,0,216.547,0Z",
    transform: "translate(-213.333)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.711 32.141)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M210.161,427.076a.8.8,0,0,0-1.388.813,2.411,2.411,0,1,1-4.175,0,.8.8,0,0,0-1.388-.813,4.019,4.019,0,1,0,6.952,0Z",
    transform: "translate(-202.666 -426.68)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5f794259.svg";
export { ForwardRef as ReactComponent };